export default {"src":"/_next/static/media/search_icon.4db99940.svg","height":33,"width":31,"blurWidth":0,"blurHeight":0};